import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import { FiberManualRecord as DotIcon } from "@mui/icons-material";
import { colorPrimary } from "../../Styles/Colors";

const NavigationDrawer = ({
  open = false,
  onClose,
  variant = "temporary",
  anchor = "left",
  width = 360,
  headline = "Navigation",
  sections = [
    {
      header: "Section Header",
      items: [
        { label: "Label", value: "100+", onClick: () => {} },
        { label: "Label", value: "100+", onClick: () => {} },
        { label: "Label", value: "100+", onClick: () => {} },
        { label: "Label", value: "100+", onClick: () => {} },
      ],
    },
    {
      header: "Section Header",
      items: [
        { label: "Label", value: "", onClick: () => {} },
        { label: "Label", value: "", onClick: () => {} },
        { label: "Label", value: "", onClick: () => {} },
      ],
    },
    {
      header: "Section Header",
      items: [
        { label: "Label", value: "", onClick: () => {} },
        { label: "Label", value: "", onClick: () => {} },
        { label: "Label", value: "", onClick: () => {} },
      ],
    },
  ],
  sx = {},
}) => {
  const drawerContent = (
    <Box
      sx={{
        width: width,
        minHeight: "90vh",
        height: "100%",
        bgcolor: "rgb(255, 240, 246)",

        padding: "8px 8px 8px 16px",
        display: "flex",
        flexDirection: "column",
        gap: 0,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          height: "56px",
          padding: "8px 8px 8px 16px",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "10px",
          alignSelf: "stretch",
        }}
      >
        {headline}
      </Typography>

      {sections.map((section, sectionIndex) => (
        <Box key={sectionIndex} style={{ padding: "8px 8px 8px 16px" }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              color: "#666",
              textTransform: "uppercase",
              fontSize: "0.75rem",
              letterSpacing: "0.5px",
              mb: 1,
              mt: sectionIndex > 0 ? 2 : 0,
            }}
          >
            {section.header}
          </Typography>

          {section.items.map((item, itemIndex) => (
            <Box
              key={itemIndex}
              component="button"
              onClick={() => {
                if (item.onClick) item.onClick();
                if (onClose && variant === "temporary") onClose();
              }}
              sx={{
                width: "100%",
                display: "flex",
                height: "56px",
                alignItems: "center",
                justifyContent: "space-between",

                bgcolor: "transparent",
                border: "none",
                cursor: "pointer",
                borderRadius: "8px",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: "rgba(96, 19, 80, 0.16)",
                  borderRadius: "100px",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <DotIcon
                  sx={{
                    fontSize: "24px",
                    color: colorPrimary,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 400,
                    color: "#374151",
                    textAlign: "left",
                  }}
                >
                  {item.label}
                </Typography>
              </Box>

              {item.value && (
                <Typography
                  sx={{
                    color: "#51434B",
                    textAlign: "right",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                  }}
                >
                  {item.value}
                </Typography>
              )}
            </Box>
          ))}

          {sectionIndex < sections.length - 1 && (
            <Divider
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.5)",
                height: "1px",
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      variant={variant}
      anchor={anchor}
      sx={{
        "& .MuiDrawer-paper": {
          width: width,
          boxSizing: "border-box",
          bgcolor: "transparent",
          border: "none",
          boxShadow: "none",

          ...sx,
        },
      }}
    >
      {drawerContent}
    </Drawer>
  );
};

export default NavigationDrawer;
